import { get } from 'lodash';
import { uid } from '@/utils';

export default {
  computed: {
    sites() {
      const keys = ['address', 'city', 'state', 'country', 'postalCode'];
      const A = { };
      const B = { };

      keys.map((k) => {
        const vA = get(this.order, `from.${k}`);
        const vB = get(this.order, `to.${k}`);
        if (vA) A[k] = vA;
        if (vB) B[k] = vB;
        return true;
      });

      return { A, B, uid: uid() };
    },
  },
};
